module.exports = __webpack_public_path__ + "static/media/IsometricBeltSquatfemale.473e5559.svg";